import React, {Component} from "react";
import begin1a from '../../../../../assets/img/begin1a.png';
import begin2new from '../../../../../assets/img/begin2new.png';
import begin3new from '../../../../../assets/img/begin3new.png';
import begin4new from '../../../../../assets/img/begin4new.png';
import begin5new from '../../../../../assets/img/begin5new.png';
import begin6new from '../../../../../assets/img/begin6new.png';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import img1 from "../../../../../assets/img/kitcut-footer--pages-images/page3-1.png";
import img2 from "../../../../../assets/img/kitcut-footer--pages-images/page3-2.png";
import img3 from "../../../../../assets/img/kitcut-footer--pages-images/page3-3.png";
import img4 from "../../../../../assets/img/kitcut-footer--pages-images/page3-4.png";


class Page3 extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <div className="faq-page-layout">
                <div className="beginners-background-div footer-nav-pages-background">

                    <h3 className='font-size-30 yu-gothic-bold '>
                        EAGLE　ガーバーデータ出力方法

                    </h3>

                    <p className='all-content-font-size '>
                        Autodesk EAGLEには、必要なファイルをすばやく作成できる便利なCAMソフトウェアーが含まれています。
                    </p>
                    <br/>
                    <p className='all-content-font-size3' >
                        <b>ドリルファイルとガーバーファイルを作成する（v.7まで、v.8以降については下を参照）</b>
                    </p>

                    <ol className="resp-ordered-list">
                        <li className='all-content-font-size3'>
                            <b> CAM プロセッサーexcellonを開く</b>

                        </li>
                        <p className='all-content-font-size '>
                            EagleでPCBレイアウト（.brd）ファイルを開き、 <b>「CAM」 </b>ボタンをクリックするか、または <b>「File - > CAM
                            Processor」 </b>を選択します。<br/> これにより、ファイルの作成に使用されているCAM Processorツールが開きます。
                        </p>
                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img1} alt=""/>
                        </p>

                        <li className='all-content-font-size3'>
                            ［<b>F</b>ile］ ＝＞［<b>Open</b>］＝＞［Job］を選択します 。

                        </li>
                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img2} alt=""/>
                        </p>
                        <br/>
                        <li className='all-content-font-size3'>
                            次に、デフォルトのEAGLE camフォルダにし、 <b> gerb274x.cam </b>ファイルを選択し、
                            開くを選択します 。
                            {/*<b>開く</b>を選択します 。*/}


                        </li>
                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img3} alt=""/>
                        </p>
                        <br/>
                        <li className='all-content-font-size3'>
                            <b>2番目にシルクスクリーンを追加する（オプション）</b> <br/>
                            {/*タブを見ると、シルクスクリーンの下部にファイルがないことがわかります。単純なボードの場合、シルクスクリーンは通常最上層にあるため、最下層は必要ありません。ただし、最下層にもシルクスクリーンが必要な場合は、次の手順に従ってください。*/}

                            {/*<br/>*/}
                            {/*「追加」をクリック*/}
                            {/*<br/>*/}
                            {/*Sectionを“ Silk Screen SOL”のように変更します*/}
                            {/*<br/>*/}
                            {/*ファイルを“％N.pls”に変更*/}
                            {/*<br/>*/}
                            {/*すべてのレイヤーの選択を解除*/}
                            {/*<br/>*/}
                            {/*レイヤ20「Dimension」、22「bPlace」、および26「bNames」を選択します。*/}


                        </li>
                        <p  className='all-content-font-size '>
                            タブを見ると、シルクスクリーンの下部にファイルがないことがわかります。
                            <br/>
                            単純なボードの場合、シルクスクリーンは通常最上層にあるため、最下層は必要ありません。
                            <br/>
                            ただし、最下層にもシルクスクリーンが必要な場合は、次の手順に従ってください。

                            <br/>
                            「追加」をクリック
                            <br/>
                            Sectionを“ Silk Screen SOL”のように変更します
                            <br/>
                            ファイルを“％N.pls”に変更
                            <br/>
                            すべてのレイヤーの選択を解除
                            <br/>
                            レイヤ20「Dimension」、22「bPlace」、および26「bNames」を選択します。
                        </p>
                        <br/>
                        <li className='all-content-font-size3'>
                            <b>[Process Job] </b>ボタンをクリックして、すべてのGerberファイルを作成します。
                            <br/>
                            プロジェクトフォルダのAutodesk
                            EAGLEコントロールパネルに、作成されたすべてのガーバーファイルがあります。
                            {/*プロジェクトフォルダのAutodesk*/}
                            {/*EAGLEコントロールパネルに、作成されたすべてのガーバーファイルがあります。*/}
                        </li>
                        <br/>
                        <p className='all-content-font-size'>
                            <b>ドリルファイルを作成する</b>
                            次にドリルリストの出力を行います。
                            <br/>
                            EAGLEが起動された状態で、CAMプロセッサーexcellon.camを起動させます。
                            <br/>
                            Control Panelより <b>「CAM Jobs」 </b>→ <b>「excellon.cam」
                        </b>をダブルクリックしてください。




                        </p>
                        <p className='all-content-font-size '>
                            これで、[ドリルデータの作成]タブが1つ表示されます。
                            <br/>
                            このタブでは、必要に応じて、レイヤ <b>44 Drills </b>と <b>45 Holes </b>からデータを取得できます。
                            <br/>
                            このファイルを作成するには <b>「Process Job」 </b>ボタンを選択します。
                        </p>
                        <p className='all-content-font-size '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img4} alt=""/>
                        </p>

                        <p className='all-content-font-size'>
                            各ガーバーファイルを作成したら、必ずGerberビューアーを使用して
                            、問題がないことを確認してください。
                            <br/>
                            それらのファイルを圧縮してKITCUT PCB注文ページにアップロードします。
                        </p>


                        {/*Eagle 9.1からGerberファイルを出力する方法については、Laurentさんが説明動画を作成されました。ご厚意に感謝いたします（v.8以降で動作）。*/}
                        {/*https://youtu.be/Jf2y1rTRHDg*/}
                        {/*Autodesk EAGLEでPCB設計用のCAMを入手するには下記のビデオをご覧ください。*/}
                        {/*https://youtu.be/Xg_uh0rsFVg*/}

                    </ol>
                </div>
            </div>
        );
    }
}

export default Page3;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/FooterNavigationPages/FooterNavPages/page3.js